<template>
  <v-row no-gutters ref="home" class="home">
    <v-col cols="12">
      <section id="banner-video" class="black">
        <div class="banner-image secondary">
          <!-- <v-img :src="banner_image" width="100%" height="100%"></v-img> -->
          <div class="banner-container primary--text">
            <div class="banner-heading">Cinematic Celebration</div>
            <div class="banner-description primary--text">
              At Cinematic Celebration, we're dedicated to crafting
              unforgettable celebrations. Our affordable yet stylish venues are
              perfect for any occasion. With a focus on customer happiness and
              flexibility, we make your moments truly special. Join our
              community of celebrators today!
            </div>
            <template v-if="!isLoading && locations.length > 0">
              <div class="banner-heading" style="font-size: 20px;">Select Location</div>
              <div class="banner-action">
                
                <v-btn
                  :to="{ name: 'LocationPage', params: { location: location.name.toLowerCase() } }"
                  color="yellow"
                  flat
                  large
                  v-for="location in locations"
                  :key="location.id"
                  class="ml-2"
                >
                  {{ location.name }}
                </v-btn>
              </div>
              <!--<div class="banner-action">
                <v-btn color="yellow" flat large class="mr-2">
                  <a
                    class="primary--text"
                    style="text-decoration: none"
                    href="tel:+917411148005"
                  >
                    Call Us
                  </a>
                </v-btn>

                <v-btn
                  :to="{ name: 'BookOnline', params: { location: 'hulimavu' } }"
                  color="yellow"
                  flat
                  large
                  class="ml-2"
                >
                  Book Now
                </v-btn>
                <v-btn
                  :to="{ name: 'BookOnline', params: { location: 'hulimavu' } }"
                  color="yellow"
                  flat
                  large
                  class="ml-2"
                >
                  Book Now
                </v-btn> -->
              <!--</div>-->
            </template>
          </div>
        </div>
      </section>
    </v-col>

    <v-col cols="12">
      <section id="about-us" class="about-us text-left secondary darken-1">
        <v-container>
          <v-card flat color="transparent" class="pa-5">
            <v-row no-gutters class="fill-height" justify="center">
              <v-col cols="12" lg="8" md="8" sm="8">
                <v-card
                  class="pa-lg-5 pa-md-5 pa-sm-3 text-center"
                  color="secondary darken-1"
                  flat
                >
                  <!-- <div class="about-us-title brown--text">ABOUT US</div> -->
                  <div class="about-us-heading primary--text">About Us</div>
                  <!-- <div class="about-us-description lightgrey--text">
                    At Cinematic Celebration, we believe that every moment in life is
                    worth celebrating, and we're here to make those moments
                    truly unforgettable.
                  </div> -->
                  <div
                    class="about-us-description secondary darken-1 primary--text"
                  >
                    "At Cinematic Celebration, we're passionate about turning
                    life's moments into unforgettable celebrations. With a
                    diverse range of celebration spaces, exceptional service,
                    and affordable luxury starting from just RS. 499/-, we're
                    dedicated to making your milestones shine. As a
                    customer-centric community of celebrators, we prioritize
                    your happiness and are ready to create tailor-made,
                    resounding successes for your special events. Join us in
                    transforming your occasions into cherished memories. Contact
                    us today to book your next unforgettable celebration at
                    Cinematic Celebration."
                    <br /><br />
                    <b>Our Celebration Spaces in Bangalore</b>
                    <br /><br />
                    Cinematic Celebration Electronic City<br />
                    Cinematic Celebration Hulimavu (Bannerghatta Road)<br />
                    Cinematic Celebration Konanakunte
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </section>
    </v-col>

    <!-- <v-col cols="12">
      <section id="how-it-works" class="how-it-works">
        <v-container>
          <v-card height="" color="primary" raised class=""> </v-card>
        </v-container>
      </section>
    </v-col> -->

    <!-- <v-col cols="12">
      <section id="our-space" class="our-space secondary">
        <v-container fluid>
          <v-row class="justify-center">
            <v-col
              cols="12"
              lg="4"
              offset-lg="2"
              offset-md="2"
              align-items="center"
            >
              <div class="text-left pr-lg-16 pr-md-16">
                <div class="our-space-title white--text">our space</div>
                <div class="our-space-heading primary--text">
                  Joyful experiences for you and your family
                </div>
                <div class="our-space-description white--text">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,
                  vero dolor asperiores veniam distinctio assumenda est!
                  Reprehenderit omnis minus dolor corrupti accusantium? Laborum
                  earum quam consequatur consectetur similique ad laboriosam.
                  <br />
                  <br />
                  Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                  Natus mollitia saepe sit tempora molestiae magnam voluptates
                  provident cupiditate sunt impedit. Reiciendis nihil dolorum
                  nobis adipisci aliquam doloribus recusandae harum sit.
                </div>
              </div>
            </v-col>
            <v-col cols="12" lg="6" md="6">
              <v-row>
                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image1})`,
                      }"
                      min-height="350"
                    >
                    </v-card>
                    <v-card color="brown" raised tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 1</div>

                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 2 },
                                }"
                              >
                                Book now at Rs299
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image2})`,
                      }"
                      min-height="350"
                    ></v-card>
                    <v-card color="brown" hover tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 2</div>

                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 1 },
                                }"
                              >
                                Book now at Rs399
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>

                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image3})`,
                      }"
                      min-height="350"
                    >
                    </v-card>
                    <v-card color="brown" hover tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 3</div>
                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 2 },
                                }"
                              >
                                Book Now at Rs499
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>
                <v-col cols="12" lg="6" md="6" sm="6">
                  <div>
                    <v-card
                      color="lightpink"
                      raised
                      style="
                        background-size: cover;
                        background-position: center;
                      "
                      :style="{
                        'background-image': `url(${our_space.image4})`,
                      }"
                      min-height="350"
                    >
                    </v-card>
                    <v-card color="brown" hover tile>
                      <v-row no-gutters justify="center" class="fill-height">
                        <v-col cols="12" align-self="center" class="text-left">
                          <div class="service-content primary--text">
                            <div class="service-title">Plan 4</div>

                            <div class="text-center">
                              <v-btn
                                small
                                color="primary"
                                class="brown--text"
                                :to="{
                                  name: 'BookOnline',
                                  params: { selectedPlanId: 2 },
                                }"
                              >
                                Book Now at Rs799
                              </v-btn>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </v-col> -->

    <v-col cols="12">
      <section id="our-space" class="our-space secondary">
        <v-container fluid>
          <v-row class="justify-center">
            <v-col cols="12" lg="12" md="12">
              <v-row no-gutters>
                <v-col cols="12">
                  <div class="our-space-heading primary--text">Our Space</div>
                </v-col>
                <!-- Render plans grouped by location -->
                
                  <v-col cols="12" v-for="location in locations" :key="location.id">
                    <div class="location-heading primary--text" style="font-size: 28px; font-weight: 700; margin-top: 20px; margin-bottom: 20px;">
                      {{ location.name }}
                    </div>
                    
                    <div class="d-flex justify-center flex-wrap">
                      <div class="plan-container" v-for="plan in getPlansForLocation(location.id).slice(0, 4)" :key="plan.id">
                        <div class="pa-3 pa-lg-8 pa-md-8 pa-sm-8">
                          <v-card
                            color="black"
                            raised
                            style="
                              background-size: cover;
                              background-position: center;
                            "
                            :style="{
                              'background-image': getBackgroundImage(plan),
                            }"
                            min-height="450"
                            class="our-space-card"
                          >
                          </v-card>
                          <v-card color="transparent" tile flat>
                            <v-row no-gutters justify="center" class="fill-height">
                              <v-col cols="12" align-self="center" class="text-left">
                                <div class="service-content primary--text">
                                  <div class="service-title">{{ plan.title }}</div>
                                  <div class="service-description">
                                    {{ plan.description }}
                                  </div>

                                  <div class="service-action">
                                    <router-link
                                      class="primary--text"
                                      :to="{
                                        name: 'LocationPage',
                                        params: { location: location.name.toLowerCase() },
                                      }"
                                    >
                                      Book now at Rs. {{ getPlanCost(plan) }}/-
                                    </router-link>
                                  </div>
                                </div>
                              </v-col>
                            </v-row>
                          </v-card>
                        </div>
                      </div>
                    </div>
                  </v-col>
                
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </section>
    </v-col>

    <v-col cols="12">
      <section id="contact-us" class="contact-us">
        <v-row no-gutters justify="center">
          <!-- <v-col cols="12" class="align-self-center">
            <div class="contact-us-heading primary--text">Visit Us</div>
          </v-col> -->
          <v-col cols="12" lg="6" md="5" class="align-self-center">
            <div class="contact-us-heading primary--text">Visit Us</div>
            <v-card color="secondary" flat tile class="contact-us-cards">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.4362817660863!2d77.5934650108159!3d12.879644016834977!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae155387af850d%3A0xea726a097976e0cf!2sCinematic%20Celebration!5e0!3m2!1sen!2sin!4v1741540657226!5m2!1sen!2sin"
                width="90%"
                height="450"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </v-card>
          </v-col>

          <v-col cols="12" lg="6" md="7">
            <div class="contact-us-heading">Contact Us</div>
            <v-card
              color="secondary"
              flat
              tile
              class="contact-us-cards primary--text fill-height"
            >
              <contact-form></contact-form>
            </v-card>
          </v-col>
        </v-row>
      </section>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import ContactForm from "@/components/ContactForm.vue";
import { getAllLocations, getAllPlans, getGalleryImages } from "@/services/booking/booking.service";
export default {
  name: "HomeView",
  components: {
    ContactForm,
  },
  async mounted() {
    try {
      // Try to load from cache first
      if (this.loadFromCache()) {
        console.log("[HomeView] Using cached data");
      } else {
        // No valid cache, fetch from API
        console.log("[HomeView] Fetching fresh data from API");
        const res = await getAllLocations();
        this.locations = res.data.data;
        console.log("[HomeView] Locations loaded:", this.locations.map(l => l.name));
        // Fetch plans for all locations
        await this.fetchAllPlans();
      }
    } catch (error) {
      console.error("Failed to fetch locations:", error);
    } finally {
      this.isLoading = false;
    }

    if (this.$route.hash) {
      this.$vuetify.goTo(this.$route.hash, {
        duration: 750,
        offset: 0,
      });
    } else {
      this.$vuetify.goTo(0, {
        duration: 750,
        offset: 0,
      });
    }
  },
  watch: {
    "$route.hash": {
      handler: function (val) {
        if (val) {
          this.$vuetify.goTo(val, { duration: 1000, offset: 0 });
        } else {
          this.$vuetify.goTo(0, {
            duration: 1000,
            offset: 0,
          });
        }
      },
    },
  },
  data() {
    return {
      banner_image:
        "https://happyharbourbucket.s3.ap-south-1.amazonaws.com/banner.jpg",
      locations: [],
      locationPlans: {}, // { locationId: [plans] }
      planGalleries: {}, // { planId: galleryData }
      isLoading: true,
      cacheExpiry: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
      cacheVersion: "v1"   // Increment this if cache structure changes to invalidate old cache
    };
  },
  methods: {
    getCacheKey() {
      return "homeview_cache";
    },
    getCacheTimestampKey() {
      return "homeview_cache_timestamp";
    },
    isCacheValid() {
      const timestamp = localStorage.getItem(this.getCacheTimestampKey());
      if (!timestamp) return false;
      const age = Date.now() - parseInt(timestamp);
      return age < this.cacheExpiry;
    },
    loadFromCache() {
      try {
        const cached = localStorage.getItem(this.getCacheKey());
        if (cached && this.isCacheValid()) {
          const data = JSON.parse(cached);

          if (data.version !== this.cacheVersion) {
            return false;
          }

          this.locations = data.locations || [];
          this.locationPlans = data.locationPlans || {};
          this.planGalleries = data.planGalleries || {};
          console.log("[HomeView] Loaded from cache");
          return true;
        }
      } catch (error) {
        console.warn("[HomeView] Cache read error:", error);
      }
      return false;
    },
    saveToCache() {
      try {
        const cacheData = {
          version: this.cacheVersion,
          locations: this.locations,
          locationPlans: this.locationPlans,
          planGalleries: this.planGalleries,
        };
        localStorage.setItem(this.getCacheKey(), JSON.stringify(cacheData));
        localStorage.setItem(this.getCacheTimestampKey(), Date.now().toString());
        console.log("[HomeView] Saved to cache");
      } catch (error) {
        console.warn("[HomeView] Cache write error:", error);
      }
    },
    /*async fetchAllPlans() {
      try {
        for (const location of this.locations) {
          const res = await getAllPlans(location.id);
          const plans = res.data.data || [];
          this.locationPlans[location.id] = plans;
          
          // Fetch gallery images for each plan
          const galleryPromises = plans.map(plan => this.fetchGalleryImage(plan.id));
          await Promise.all(galleryPromises);
        }
        
        // Save to cache
        this.saveToCache();
      } catch (error) {
        console.error("[HomeView] Failed to fetch plans:", error);
      }
    },*/
    async fetchAllPlans() {
      try {
        // Fetch plans for all locations in parallel
        const planPromises = this.locations.map(location =>
          getAllPlans(location.id)
        );

        const planResponses = await Promise.all(planPromises);

        // Store plans by location
        planResponses.forEach((res, index) => {
          const locationId = this.locations[index].id;
          this.locationPlans[locationId] = res.data.data || [];
        });

        // Collect all plans
        const allPlans = Object.values(this.locationPlans).flat();
        //alert(JSON.stringify(allPlans));

        // Fetch all galleries in parallel
        const galleryPromises = allPlans.map(plan =>
          this.fetchGalleryImage(plan.id)
        );

        await Promise.all(galleryPromises);

        // Save cache
        this.saveToCache();

      } catch (error) {
        console.error("[HomeView] Failed to fetch plans:", error);
      }
    },
    async fetchGalleryImage(planId) {
      try {
        const res = await getGalleryImages(planId);
        
        // Check if API call was successful
        if (res.data?.success === 1 && res.data?.data) {
          this.planGalleries[planId] = res.data.data;
        }
      } catch (error) {
        console.error(`[HomeView] Gallery fetch failed for plan ${planId}:`, error.message);
      }
    },
    getPlansForLocation(locationId) {
      return this.locationPlans[locationId] || [];
    },
    getPlanCost(plan) {
      return plan.givediscount
        ? plan.amount - plan.maxdiscount
        : plan.amount;
    },
    getBackgroundImage(plan) {
      const gallery = this.planGalleries[plan.id];
      
      if (gallery && gallery.galleryimages) {
        try {
          let images;
          
          // Try to parse as JSON first (in case it's stored as JSON array)
          try {
            images = JSON.parse(gallery.galleryimages);
          } catch (jsonError) {
            // If JSON parsing fails, treat as comma-separated string
            images = gallery.galleryimages.split(',').map(img => img.trim());
          }
          
          if (Array.isArray(images) && images.length > 0) {
            const imagePath = images[0];
            let imageUrl = imagePath;
            if (!imagePath.startsWith('http')) {
              imageUrl = `http://localhost:8081/${imagePath}`;
            }
            return `url(${imageUrl})`;
          } else if (typeof images === 'string') {
            let imageUrl = images;
            if (!images.startsWith('http')) {
              imageUrl = `http://localhost:8081/${images}`;
            }
            return `url(${imageUrl})`;
          }
        } catch (e) {
          console.warn(`[HomeView] Error parsing gallery for plan ${plan.id}:`, e.message);
        }
      }
      // Return placeholder if no image
      return 'url(data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 400"%3E%3Crect fill="%23333" width="400" height="400"/%3E%3C/svg%3E)';
    },
    scrollTo(id) {
      this.$router.push({ name: "HomeView", hash: id });
    },
  },
};
</script>
<style scoped>
.home .banner-video {
  position: relative;
  height: calc(100vh - 64px);
  width: 100%;
}

.home .banner-video .banner-text {
  color: white;
  font-size: 50px;
  font-weight: 700;
  position: absolute;
  top: 70%;
  left: 15%;
  transform: translate(-15%, -70%);
}

.home .banner-video .banner-button {
  position: absolute;
  top: 95%;
  left: 50%;
  transform: translate(-50%, -95%);
}

.home .banner-video .banner-text h1 {
  line-height: 1;
}

.home .banner-video .banner-text h3 {
  margin-left: 10px;
}

.home .banner-image {
  position: relative;
  height: calc(100vh - 64px);
  width: 100%;
  /* background-image: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ),
    url("../assets/banner.jpg"); */
  background-image: url("../assets/banner_new.webp");
  background-size: cover;
}

.home .banner-container {
  position: absolute;
  width: 30%;
  top: 70%;
  left: 80%;
  transform: translate(-80%, -70%);
  text-align: left;
  padding: 30px;
  /* border: 20px solid #ccdad1; */
  border: 20px solid #ebc363;
}
.home .banner-container .banner-heading {
  font-size: 50px;
  font-weight: 700;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.45);
}
.home .banner-container .banner-description {
  margin: 25px 0;
  font-size: 18px;
  line-height: 1.5;
  word-wrap: break-word;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
  font-style: italic;
}


.home .our-space,
.home .testimonial,
.home .contact-us {
  padding: 100px 0;
}

.home .about-us .about-us-title,
.home .our-space .our-space-title,
.home .testimonial .testimonial-title,
.home .contact-us .contact-us-title {
  font-size: 24px;
  line-height: 28px;
  font-weight: 300;
  text-transform: uppercase;
  /* letter-spacing: 2px; */
  margin-bottom: 22px;
}

.home .about-us .about-us-heading,
.home .our-space .our-space-heading,
.home .testimonial .testimonial-heading,
.home .contact-us .contact-us-heading {
  font-size: 48px;
  line-height: 52px;
  font-weight: 700;
  margin-bottom: 30px;
}

.home .our-space .our-space-card {
  border: 4px solid;
}
.home .our-space .our-space-description {
  font-size: 16px;
  line-height: 25px;
}
.home .about-us .about-us-description {
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 20px;
  font-weight: 500;
  font-style: italic;
}

.home .about-us .about-us-image {
  height: 250px;
  background-position: center;
}

.home .about-us .about-us-image.image3 {
  height: 508px;
}

.home .testimonial .review-image {
  background-position: top;
}

.home .testimonial .review-image,
.home .about-us .about-us-image {
  background-repeat: no-repeat;
  background-size: cover;
}

.home .our-space .service-content {
  padding: 32px 0;
  text-align: left;
}

.home .plan-container {
  flex: 0 0 100%;
  max-width: 100%;
  padding: 0 12px;
  margin-bottom: 24px;
}

@media (min-width: 600px) {
  .home .plan-container {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
  }
}

@media (min-width: 1264px) {
  .home .plan-container {
    flex: 0 0 25%;
    max-width: 25%;
  }
}

.home .our-space .service-title {
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 2px;
  font-weight: 700;
}
.home .our-space .service-description {
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 1.2px;
  font-style: italic;
  font-weight: 500;
  margin: 20px 0;
}
.home .our-space .service-action a {
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 1.2px;
  font-style: italic;
  font-weight: 500;
  margin: 20px 0;
  text-decoration: none;
  padding-bottom: 4px;
  border-bottom: 2px solid;
}
.home .contact-us-cards {
  padding: 60px 0;
}

@media only screen and (max-width: 1024px) {
  .home .banner-container {
    width: 45%;
  }
}

@media only screen and (max-width: 600px) {
  .home .banner-container {
    position: relative;
    width: 90%;
    margin: auto;
    top: 70%;
    left: 0%;
    transform: translate(0%, -70%);
    padding: 15px;
    border: 10px solid #ccdad1;
  }
  .home .banner-container .banner-heading {
    font-size: 40px;
  }
  .home .banner-container .banner-description {
    margin: 25px 0;
    font-size: 18px;
  }
  .home .about-us .about-us-image {
    height: 120px;
  }

  .home .about-us .about-us-image.image3 {
    height: 248px;
  }
}

@media only screen and (max-width: 960px) {
  .home .banner-video {
    height: calc(100vh - 56px);
  }

  .home .banner-video .banner-text {
    font-size: 30px;
  }

  .home .about-us,
  .home .our-space,
  .home .testimonial,
  .home .contact-us {
    padding: 50px 0;
  }

  .home .about-us .about-us-heading,
  .home .our-space .our-space-heading,
  .home .testimonial .testimonial-heading,
  .home .contact-us .contact-us-heading {
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 30px;
  }

  .home .about-us .about-us-description {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 20px;
  }

  .banner-action .ml-2 {
    margin-bottom: 15px !important;
  }
}
</style>
